"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["navbar.horizontal-style-1{display:flex;flex-direction:column;flex:1 1 auto;width:100%;height:56px;max-height:56px;min-height:56px}"];
exports.styles = styles;
